import { render } from "./InvestimentModal.vue?vue&type=template&id=79a28484&ts=true"
import script from "./InvestimentModal.vue?vue&type=script&lang=ts"
export * from "./InvestimentModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__